import {
  getSitePackageDefinition,
  sitePackageIdFromRecipeId,
  SitePackageIdSchema,
  type SitePackageId,
} from "@enrein/shared-contracts";

const SHORT_LABEL_OVERRIDES: Partial<Record<SitePackageId, string>> = {
  "package-one-page": "One page",
  "package-basic-3": "Basic 3",
  "package-standard-5": "Standard 5",
  "package-growth-8": "Growth 8",
  "package-authority-10": "Authority 10",
  "package-authority-15": "Authority 15",
};

export function sitePackageDisplayLabel(sitePackageId: string | null | undefined): string {
  if (!sitePackageId) return "Unknown package";
  const parsed = SitePackageIdSchema.safeParse(sitePackageId);
  if (!parsed.success) return sitePackageId;
  const id = parsed.data;
  return SHORT_LABEL_OVERRIDES[id] ?? getSitePackageDefinition(id).displayName;
}

export function sitePackageLabelFromRecipeId(recipeId: string): string {
  try {
    return sitePackageDisplayLabel(sitePackageIdFromRecipeId(recipeId));
  } catch {
    return recipeId;
  }
}
